import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Container,
  Nav,
  Navbar,
  Dropdown,
  NavItem,
} from "react-bootstrap";
import authApi from "../../../api/authApi";
import jwt_decode from "jwt-decode";
import "./Header.css";
import { useNavigate, useLocation, NavLink } from "react-router-dom";
import PubSub from "pubsub-js";
// import WhiteObjectApi from "../../../api/WhiteObjectApi";
import Notification from "../common/Notification";
import logo from "../../../assets/img/fuziElevatorsLogo.jpg"
import { ROUTES } from "../../../constants/webRouting";
import fuziElevatorsApi from "../../../api/fuziElevatorsApi";

import audioUrl from '../../../assets/sounds/notification_sound.mp3';
import PERMISSIONS from "../../../constants/permissions";
import { getUserDetails } from "../../../utils/helper";

const Header = ({
  socket,
  // leadCreationIndicator
}) => {
  const [audio] = useState(new Audio(audioUrl));
  const navigate = useNavigate();
  const location = useLocation();
  const [userInfo, setUserInfo] = useState(getUserDetails() || null);
  // const [notificationCount, setNotificationCount] = useState(2);
  const [refreshNotification, setRefreshNotification] = useState(new Date());
  const [showBellAlert, setShowBellAlert] = useState(false);
  const [unreadMsgCount, setUnreadMsgCount] = useState(0);
  const [messages, setMessages] = useState([]);
  const [showNotification, setShowNotification] = useState(false);
  const showNotificationRef = React.useRef(false);
  const [navItems, setNavItems] = useState([
    { label: "Home", path: ROUTES.HOME, permissions: [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_DASHBOARD] },
    { label: "New Enquiry", path: ROUTES.LEAD.LIST, permissions: [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_LEAD] },
    { label: "Site Visits", path: ROUTES.USER_TRACKING, permissions: [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_SITE_VISIT] },
    { label: "Offers", path: ROUTES.OFFER.LIST, permissions: [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_OFFER] },
    { label: "Orders", path: ROUTES.ORDER.LIST, permissions: [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_ORDER] },
    { label: "Warranty", path: ROUTES.WARRANTY.LIST, permissions: [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_WARRANTY] },
    { label: "AMC", path: ROUTES.ORDER_AMC.LIST, permissions: [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_AMC] },
    { label: "Reports", path: ROUTES.REPORT.LIST, permissions: [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_REPORT] },
    { label: "Contacts", path: ROUTES.CONTACT.LIST, permissions: [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_CONTACT] },
    { label: "Make", path: ROUTES.ACCOUNT.LIST, permissions: [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_MAKE] },
    { label: "Site visit report", path: ROUTES.SITE_VISIT_REPORT.LIST, permissions: [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_SITE_VISIT] },   // Added by Imran Khan on 18-March-2026
    // { label: "Handover", path: ROUTES.HANDOVER.LIST },
    { label: "Users", path: ROUTES.USER.LIST, permissions: [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_USER] },
    { label: "Products", path: ROUTES.PRODUCT.LIST, permissions: [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_PRODUCT] },
    { label: "Backups", path: ROUTES.BACKUP, permissions: [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_BACKUP] },
  ]);
  const spliceCount = 8;
  const handleNavigation = (path) => {
    navigate(path);
  };

  useEffect(() => {
    // console.log("header rend")
    const token = localStorage.getItem("token");
    if (!token) {
      navigate(ROUTES.LOGIN);
    } else {
      // const notifications = JSON.parse(
      //   localStorage.getItem("notifications") || "[]"
      // );

      // if (notifications.length > 0) {
      //   navigate("/maintanance");
      // }
      try {// Changes by shahir hussain 05-01-2025
        // const decodedToken = jwt_decode(token);
        // setUserInfo(decodedToken ? decodedToken : '');
        const userInfo = getUserDetails();
        setUserInfo(userInfo || null);
        userInfo.userrole == "SUPER_ADMIN" && setNavItems((prev) => {
          const alreadyExists = prev.some(item => item.path === ROUTES.SETTINGS);//Added by shahir hussain 05-01-2025
          const pricingMasterExists = prev.some(item => item.path === ROUTES.PRICING_MASTER.LIST);
          const marginMasterExists = prev.some(item => item.path === ROUTES.MARGIN_MASTER.LIST);
          if (alreadyExists && pricingMasterExists && marginMasterExists) return prev;//Added by shahir hussain 05-01-2025

          const newItems = [...prev];
          if (!alreadyExists) {
            newItems.push({ label: "Settings", path: ROUTES.SETTINGS, permissions: [PERMISSIONS.VIEW_ALL] });
          }
          if (!pricingMasterExists) {
            newItems.push({ label: "Pricing Master", path: ROUTES.PRICING_MASTER.LIST, permissions: [PERMISSIONS.VIEW_ALL] });
          }
          if (!marginMasterExists) {
            newItems.push({ label: "Margin Master", path: ROUTES.MARGIN_MASTER.LIST, permissions: [PERMISSIONS.VIEW_ALL] });
          }
          return newItems;
        }

        );

      } catch (error) {
        console.log('Error', error);
      }
    }

    //commented by shahir hussain 21-08-2025 for stop by default show notification
    // if (location.pathname == ROUTES.HOME) {
    //   playBellSound();
    //   messageList(true, true);
    // }else{
    //   init(false, false);
    // }

    //Added by shahir hussain 21-08-2025
    init(false, false);

    if (socket) {
      const user = getUserDetails();
      if (user?.id) {
        socket.emit("setup", user);
      }
    }
  }, [socket]); 
  // Imran Khan Updated useEffect to use socket connection 0n 18-March-2026
  useEffect(() => {
    const handleNewNotification = (e) => {
      console.log("Header notification received", e.detail);
      //playBellSound();       // Imran Khan Update AMC Ticket 1077 on 01-June-2026               
      showNotificationRef.current = true;   
      setShowNotification(true);

      // FIX: e.detail se actual triggered notification dikhao — result[0] nahi
      const detail = e.detail;
      if (detail) {
        const msg = detail.description
          ? detail.description.replace(/<[^>]*>?/gm, "").substring(0, 60)
          : detail.message || detail.title || "New Notification";
        PubSub.publish("NOTIFICATION_TOAST", {
          title: detail.title || detail.sender_name || "New Notification",
          message: msg + (msg.length >= 60 ? "..." : ""),
        });
      }

      messageList(false, false, false); // showToast false — upar se already publish kar diya
    };

    window.addEventListener("new-notification", handleNewNotification);

    return () => {
      window.removeEventListener("new-notification", handleNewNotification);
    };
  }, []);

  useEffect(() => {
    if (!userInfo) return;
    setNavItems((prev) =>
      prev.filter((item) =>
        item.permissions.some((permission) =>
          userInfo.permissions.map((p) => p.name).includes(permission)
        )
      )
    );
  }, [userInfo]);

  // useEffect(() => { messageList(true, false) }, [unreadMsgCount]);   

  const formatMessage = (mystr) => {
    let oldStr = mystr;
    mystr = mystr.substring(1);
    var arry = mystr.split(" @");
    var returnArr = [];

    for (var a of arry) {
      var obj = {};
      var value = a.substring(a.lastIndexOf("[") + 1, a.lastIndexOf("]"));
      var key = a.substring(a.lastIndexOf("(") + 1, a.lastIndexOf(")"));
      obj[`username`] = value;
      obj[`id`] = key;
      if (key) returnArr.push(obj);
    }

    for (var a of returnArr) {
      oldStr = oldStr.replace(
        `@[${a.username}](${a.id})`,
        `<a href="/users/${a.id}">${a.username}</a>`
      );
    }

    return oldStr;
  };

  async function init(open, play, showToast = false) {
    let result = await fuziElevatorsApi.fetchUnreadMessages();
    // console.log('result', result);
    //let tasks = [];
    //  console.log("tasks.length", tasks)
    if (result && result?.length > 0) {
      result.forEach((message) => {
        message.description = formatMessage(message.description);
      });


      const readMessages = result.filter((message) => message.status === "New");
      setUnreadMsgCount(readMessages.length);
      setMessages(result);
      // setShowNotification((prev)=>!prev);
      setShowBellAlert((prev) => !prev);

      // FIX: RECORD_SAVED_TOAST ki jagah NOTIFICATION_TOAST use karo
      // Taaki order save toast aur socket notification toast alag rahe — duplicate band
      if (showToast && result[0]) {
        const cleanDesc = result[0].description.replace(/<[^>]*>?/gm, "").substring(0, 60);
        PubSub.publish("NOTIFICATION_TOAST", {
          title: "New Notification",
          message: cleanDesc + (cleanDesc.length >= 60 ? "..." : "")
        });
      }

      if (play)
        playBellSound();

      if (open) {
        showNotificationRef.current = true;
        setShowNotification(true);
      }
    } else {
      setMessages([]);
      setUnreadMsgCount(0);
      // setShowNotification(open);
    }
  }
  const messageList = (open, play, showToast = false) => {
    init(open, play, showToast);
  };

  const playBellSound = async () => {
    try {
      audio.currentTime = 0;
      await audio.play();
    } catch (e) {
      console.error("Playback error:", e);
    }
  };

  const logout = async () => {
    await authApi.logout();
    navigate(ROUTES.LOGIN);
  };

  const closeNotification = () => {
    setShowNotification(false);
    showNotificationRef.current = false;
  };

  const openNotificationArea = () => {
    if (!showNotificationRef.current) {
      // playBellSound();
      messageList(true, false);
      setShowNotification(true);
      showNotificationRef.current = true;
    } else {
      setShowNotification(false);
      showNotificationRef.current = false;
    }
  };

  return (
    <Navbar expand="lg" className="bg-body-header" variant="light">
      <Container fluid>
        <Navbar.Brand>
          <img
            src={logo}
            alt="Fuzi Elevators"
            style={{
              width: "190px",
              height: "63px",
              // marginRight: "151px",
              filter: "unset",
            }}
          />
        </Navbar.Brand>

        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-between" >
          <Nav id="navbar-menu" >

            {[...navItems].splice(0, spliceCount).map((navItem, index) => (

              <NavLink
                to={navItem.path}
                // onClick={() => handleNavigation(navItem.path)}
                // to={navItem.path}
                className={({ isActive, isPending }) => `${(isPending ? "" : isActive ? "active-tab" : "inactive-tab")} nav-link `}
                key={index}
              >
                {navItem.label}
              </NavLink>

            ))}

            {[...navItems].splice(spliceCount).length > 0 && (
              <Dropdown>
                <Dropdown.Toggle
                  variant="link"
                  id="dropdown-basic"
                  className="mx-3"
                  style={{
                    fontSize: "18px",
                    padding: "10px 15px",
                    lineHeight: "1.5em",
                    zIndex: 1051,
                  }}
                />
                <Dropdown.Menu style={{ zIndex: 1051, position: "absolute" }}>
                  {[...navItems].splice(spliceCount).map((navItem, index) => (
                    <Dropdown.Item
                      onClick={() => handleNavigation(navItem.path)}
                      className={`${
                        location.pathname.includes(navItem.path) ? "isActive" : "inactive"
                      }`}
                      key={index}
                    >
                      {navItem.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            )}
          </Nav>

          <Nav className="justify-content-center align-items-center gap-2">
            <Nav.Link
              className="m-2 p-0"
              style={{ fontSize: ".9rem" }}
              onClick={() => handleNavigation(ROUTES.PROFILE)}
            >
              <img
                src="https://www.w3schools.com/bootstrap4/img_avatar3.png"
                className="rounded-circle"
                style={{ height: "30px" }}
                alt=""
              />
              <Badge style={{ fontSize: ".9rem", color: "#1b1313" }} bg="#244c7e">
                {userInfo?.username}
              </Badge>
              <Badge bg="secondary" style={{ fontSize: "10px !important", position: "relative" }}>
                {userInfo?.userroleA === "SYS_ADMIN" ? "SUPER ADMIN" : userInfo?.userroleA}
              </Badge>
            </Nav.Link>

            <div>
              <span className="" onClick={openNotificationArea}>
                <i className="fs-5 fa fa-bell fa-regular"></i>
                <sup className="bg-custom rounded-circle text-white px-1">
                  {unreadMsgCount}
                </sup>
              </span>
            </div>

            {showNotification && (
              <Notification
                notifications={messages.slice(0, 20)}
                closeNotification={closeNotification}
                refreshNotification={refreshNotification}
                messageList={messageList}
                setShowNotification={(val) => {
                  setShowNotification(val);
                  showNotificationRef.current = val;
                }}
              />
            )}

            <Button className="btn-custom" onClick={() => logout()}>
              <i className="fa-solid fa-right-from-bracket" />
            </Button>
          </Nav>
        </Navbar.Collapse>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
      </Container>
    </Navbar>
  );
};

export default Header;
